// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiAnnual {
    static getAttributeTypeMap() {
        return PharmacyBiAnnual.attributeTypeMap;
    }
}
PharmacyBiAnnual.discriminator = undefined;
PharmacyBiAnnual.additionalProperties = false;
PharmacyBiAnnual.attributeTypeMap = [
    {
        "name": "cap",
        "baseName": "cap",
        "type": "string"
    },
    {
        "name": "capMetAmount",
        "baseName": "capMetAmount",
        "type": "string"
    },
    {
        "name": "capExists",
        "baseName": "capExists",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiAnnual.js.map